"use client"
import { SeasonStatusComponent } from "./seasonStatusComponent"
import { SeasonCurrencyComponent } from "./seasonCurrencyComponent"
import { SeasonButtonComponent } from "./seasonButtonComponent"
import { SeasonProgressComponent } from "./seasonProgressComponent"
import { getTitleData } from "@/app/dashboard/dashboardAction"
import { useAppDispatch, useAppSelector } from "@/app/redux/hooks/reduxHooks"
import { seasonPassInformation } from "@/lib/seasonPass"
import PromotionModal from "./promotionModal"
import { useEffect } from "react"
import { toast } from "react-toastify"

type Props = {
    sessionTicket: string
}

export const SeasonComponent: React.FC<Props> = (props) => {
    const { sessionTicket } = props
    const seasonPass = useAppSelector((state) => state.auth.seasonPass)
    const dispatch = useAppDispatch()

    const fetchTitleData = async () => {
        if (seasonPass !== null) {
            try {
                const response = await getTitleData(sessionTicket)
                console.log("season response: ", response)
                const seasonResponse = JSON.parse(response.data.data.Data.seasonInfo)
                const payload = await seasonPassInformation(
                    seasonPass!,
                    seasonResponse.BronzeTierCost,
                    seasonResponse.SilverTierCost,
                    seasonResponse.GoldTierCost
                )
                dispatch({ type: "dashboard/setSeasonInfo", payload })
            } catch (error: any) {
                toast.error("Error fetching title data: ", error)
            }
        }
    }

    useEffect(() => {
        fetchTitleData()
    }, [seasonPass])

    return (
        <section className="relative z-10">
            <section className="block md:flex gap-7">
                <section>
                    <h2 className="text-[20px] mb-2 text-shadow-md">SEASON OVERVIEW</h2>
                    <div className="border border-[#4E4E4E] p-5 w-full sm:w-[475px]  bg-[url('/season-bg-v2.webp')] bg-cover shadow-lg">
                        <SeasonStatusComponent />
                        <SeasonCurrencyComponent />
                        <p>
                            Contribute a minimum of 1,000 credits to your status. If you are short on credits, use our
                            currency converter to convert shards to credits.
                        </p>
                        <SeasonButtonComponent />
                    </div>
                </section>
                <section>
                    <SeasonProgressComponent />
                </section>
            </section>
            <PromotionModal />
        </section>
    )
}
